/* unplugin-vue-components disabled */import { render } from "./virtualList.vue?vue&type=template&id=63b1629e&scoped=true"
import script from "./virtualList.vue?vue&type=script&lang=js"
export * from "./virtualList.vue?vue&type=script&lang=js"

import "./virtualList.vue?vue&type=style&index=0&id=63b1629e&scoped=true&lang=scss"

import exportComponent from "/root/.jenkins/workspace/高保障-门户上海杉达-前台页面/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63b1629e"]])

export default __exports__